// 封装一个axios的实例
import Axios from 'axios';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css'
import Config from '../config';

// 创建一个新的实例
let r = Axios.create({
    baseURL: `${Config.serverHost}/`,
    withCredentials: false, // 允许客户端再跨域的时候携带cookie
});

// 发请求之前(自动添加头信息)
r.interceptors.request.use(function(config) {
    NProgress.start();
    return config;
});


// 定义响应的拦截器
r.interceptors.response.use(function(res) {

    NProgress.done();
 
    return res;
});

let request = function(url = '', options = {}) {
    return function() {
        
        if (url === '') return Promise.reject('必须传递url');
        
        // 将promise对象返回去
        return r({
            url,
            //method: 'get', // method先给一个get请求
            ...options // options中有method就会覆盖
        });

    }
}


export default request;